import React from 'react'
import SocialShare from '../../../ui/SocialShare'
import Title from '../../../ui/Title'

const Share = ({ title, ...props }) => (
  <div>
    <Title>{title}</Title>
    <SocialShare {...props} />
  </div>
)

export default Share
